import React, {useEffect, useRef,useState } from "react"; 
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import { handleFileValidation } from "../../../../utils/Api";
import { createOfflineGame, updateOfflineGame, getOfflineGameByID} from "../../../../Services/OffliineGames/offlineGamesServices";
import Form from 'react-bootstrap/Form';
const CreateGame = ({ isShow,close, type,gameId }) => {  
  const handleShow = () => setShow(true);
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [gameName, setGameName] = useState("");
  const [gameID, setGameID] = useState("");
  const [asset, setAsset] = useState("");
  const [banners, setBanner] = useState("");
  const [description, setDescription] = useState("");
  const [gameIDError, setGameIDError] = useState("");  
  const [gameNameError, setGameNameError] = useState("");  
  const [descriptionError, setDescriptionError] = useState("");  
  const [assetError, setAssetError] = useState("");  
  const [bannerError, setBannerError] = useState("");  
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubjectError, setSelectedSubjectError] = useState(false);
  const [selectedCategoryError, setSelectedCategoryError] = useState(false);
  const gameNameRef=useRef(null)
  const descriptionRef=useRef(null)
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState("");
  const nameRef = useRef(null);
  const gameIdRef = useRef(null);
  const MAX_FILE_SIZE = 500 * 1024 * 1024;
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      setFileError("Please provide a file.");
      setFile(null);
      return;
    }
    if (!selectedFile.name.endsWith(".zip")) {
      toast.error("Please provide a .zip format file only.");
      setFile(null);
      e.target.value = null;
      return;
    }
    if (selectedFile.size > MAX_FILE_SIZE) {
      toast.error("File size should not exceed 500MB.");
      setFile(null);
      e.target.value = null;
      return;
    }
    setFileError("");
    setFile(selectedFile);
  };
  const subjects = [
    { id: 1, name: "English" },
    { id: 2, name: "Maths" }
  ];
  const categories = [
    { id: 1, name: "Identification", subjectId: 1 },
    { id: 2, name: "Spellings", subjectId: 1 },
    { id: 3, name: "Other", subjectId: 1 },
    { id: 4, name: "Identification", subjectId: 2 },
    { id: 5, name: "Counting", subjectId: 2 },
    { id: 6, name: "Addition", subjectId: 2 },
    { id: 7, name: "Subtraction", subjectId: 2 },
    { id: 8, name: "Other", subjectId: 2 }
  ];
  useEffect(() => {
    setShow(isShow);
    if (type === "EDIT" && gameId) {
      fetchGameDetails();
    }
  }, [isShow, type, gameId]);

  const fetchGameDetails = async () => {
    try {
      const response = await getOfflineGameByID(gameId);
      if (response?.status) {
            setGameName(response.data.name)
            setGameID(response.data.id)
            setDescription(response.data.description)
            setSelectedCategory(response.data.category_id)
            setSelectedSubject(response.data.subject_id)
      } else {
        toast.error("Failed to fetch subject details");
      }
    } catch (error) {
      console.error("Error fetching subject details:", error);
    }
  };
    const handleSubjectChange = (e) => {
      const subjectId = e.target.value;
      setSelectedSubject(subjectId);
      setSelectedCategory(""); 
      setSelectedSubjectError(false);
    };
    const filteredCategories = categories.filter(
      (category) => category.subjectId == selectedSubject
    );
    const handleThumbnailChange = (e) => handleFileValidation(e, setAsset,setAssetError);
    const handleBannerChange = (e) => handleFileValidation(e, setBanner,setBannerError);
    const handleSubmit = async () => {
        if (!gameID || !gameName.trim() ||(type=="CREATE" && !file)||(type=="CREATE" && !asset)||(type=="CREATE" && !banners) || !description || !selectedCategory || !selectedSubject) {
          setGameIDError(!gameID);
          setGameNameError(!gameName.trim());
          setDescriptionError(!description.trim());
          setFileError(type=="CREATE" && !file)
          setSelectedCategoryError(!selectedCategory)
          setSelectedSubjectError(!selectedSubject)
          setAssetError(!asset)
          setBannerError(!banners)
  
          let object = [
            {
                key: gameID,
                ref: nameRef.current,
            },
            {
                key: gameName.trim(),
                ref: nameRef.current,
            }, 
            {
                key: description.trim(),
                ref: descriptionRef.current,
            }      
          ];

          for (let i = 0; i < object.length; i++) {
            if (!object[i].key) {
              object[i].ref?.focus();
              break;
            }
          }
          return;
        }
        setIsLoading(true)
        setIsDisabled(true)
        const formData = new FormData();
        formData.append('name', gameName);
        formData.append('description', description);
        formData.append('category_id', selectedCategory);
        formData.append('subject_id', selectedSubject);
        formData.append('asset', asset);
        formData.append('banner', banners);
        formData.append('game', file);

        try {
          let response;
          if (type=="CREATE") {
            formData.append('game_id', gameID);
            response = await createOfflineGame(formData);
          } else {
            formData.append('game_id', gameId);
            response = await updateOfflineGame(formData);
          }
    
          if (response.status) {
            toast.success(response.message);
            close();
          } else {
            toast.error(response.errorMessage);
          }
        } catch (error) {
          toast.error("Something went wrong!");
        } finally {
          setIsLoading(false);
          setIsDisabled(false);
        }
      };
  return ( 
    <Modal show={show} onHide={handleClose} dialogClassName="modal-xl">
        <Modal.Header closeButton>
        <h5 className="modal-title">{type === "CREATE" ? "Add Offline Game" : "Edit Offline Game"}</h5>
        </Modal.Header>
        <Modal.Body>
        <form className="row g-3">
                  <div className="col-6 px-3">
                    <label htmlFor="NewGameName" className="form-label required">Game ID</label>
                    <input
                      id='number'
                      ref={gameIdRef}
                      maxLength={70}
                      value={gameID}
                      disabled={type=="EDIT"}
                      onChange={(e) => {
                        setGameID(e.target.value);
                        if (gameNameError && e.target.value.trim() !== '') {
                          setGameIDError(false);
                        }
                      }}
                      type="number"
                      className="form-control"
                      placeholder="Enter Game ID"
                    />
                  <Form.Control.Feedback type="invalid" style={{ display: gameIDError ? 'block' : 'none' }}>
                    Game ID is required
                  </Form.Control.Feedback>
                  </div>
              <div className="col-6 px-3">
                <label htmlFor="NewGameName" className="form-label required">Name</label>
                <input
                  id='name'
                  ref={gameNameRef}
                  maxLength={70}
                  value={gameName}
                  onChange={(e) => {
                    setGameName(e.target.value);
                    if (gameNameError && e.target.value.trim() !== '') {
                      setGameNameError(false);
                    }
                  }}
                  type="text"
                  className="form-control"
                  placeholder="Enter Game Name"
                />
              <Form.Control.Feedback type="invalid" style={{ display: gameNameError ? 'block' : 'none' }}>
                Game name is required
              </Form.Control.Feedback>
              </div>
              <div className="col-6 px-3">
                  <label htmlFor="NewGameSubject" className="form-label required">
                    Subject
                  </label>
                  <select
                    className="form-control"
                    value={selectedSubject}
                    onChange={handleSubjectChange}
                  >
                    <option value="" disabled>
                      Select Subject
                    </option>
                    {subjects.map((subject) => (
                      <option key={subject.id} value={subject.id}>
                        {subject.name}
                      </option>
                    ))}
                  </select>
                <Form.Control.Feedback type="invalid" style={{ display: selectedSubjectError ? 'block' : 'none' }}>
                 Subject is required
                </Form.Control.Feedback>
                </div>
                <div className="col-6 px-3">
                  <label htmlFor="NewGameCategory" className="form-label required">
                    Category
                  </label>
                  <select
                    className="form-control"
                    value={selectedCategory}
                    onChange={(e) => {
                      setSelectedCategory(e.target.value);
                      setSelectedCategoryError(false);
                    }}
                    disabled={!selectedSubject || filteredCategories.length === 0}
                  >
                    <option value="" disabled>
                      Select Category
                    </option>
                    {filteredCategories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                <Form.Control.Feedback type="invalid" style={{ display: selectedCategoryError ? 'block' : 'none' }}>
                  Category is required
                </Form.Control.Feedback>
                </div>
              <div className="col-6 px-3">
                <label htmlFor="NewGameDescription" className="form-label required">Description</label>
                <input
                  id='name'
                  ref={descriptionRef}
                  value={description}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    if (descriptionError && e.target.value.trim() !== '') {
                      setDescriptionError(false);
                    }
                  }}
                  type="text"
                  className="form-control"
                  placeholder="Enter description"
                />
              <Form.Control.Feedback type="invalid" style={{ display: descriptionError ? 'block' : 'none' }}>
                Description is required
              </Form.Control.Feedback>
              </div>  
              <div className="col-6 px-3">
                    <label htmlFor="NewGameFile" className="form-label required">
                      Select Game File
                    </label>
                    <input
                      type="file"
                      name="game"
                      id="NewGameFile"
                      className="form-control"
                      accept=".zip,application/zip,application/x-zip-compressed"
                      onChange={handleFileChange}
                    />
                  <Form.Control.Feedback type="invalid" style={{ display: fileError ? 'block' : 'none' }}>
                    Game File is required
                  </Form.Control.Feedback>
                  </div>
              <div className="col-6 px-3">
                  <label htmlFor="gameThumnail" className="form-label required">Game Thumbnail</label>
                  <input id="gameThumnail" onChange={handleThumbnailChange}
                   name="asset" type="file" className="form-control" accept=".png, .jpg, .jpeg" />
                  <Form.Control.Feedback type="invalid" style={{ display: assetError ? 'block' : 'none' }}>
                      Game Thumbnail is required
                  </Form.Control.Feedback>
                </div>
                <div className="col-6 px-3">
                  <label htmlFor="gameBanner" className="form-label required">Game Banner</label>
                  <input id="gameBanner"  
                  onChange={handleBannerChange}
                name="asset" type="file" className="form-control" accept=".png, .jpg, .jpeg" />
                  <Form.Control.Feedback type="invalid" style={{ display: bannerError ? 'block' : 'none' }}>
                      Game Banner is required
                  </Form.Control.Feedback>
                </div>
                <div className="modal-footer" >
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={()=>{handleClose()}}
                >
                  Close
                </button>
                <button
                  id="creategame"
                  type="button"
                  className="btn btn-primary"
                  disabled={isDisabled || isLoading}
                  onClick={handleSubmit}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>{" "}
                      Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </form>          
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
       
  );
};

export default CreateGame;
